import { setClaims } from '@/app/redux/slices/sessionSlice';
import { AppDispatch } from '@/app/redux/store';
import { Invitation } from '@/common/types/organisation';
import { refreshUserClaims } from '@/common/utils/auth';
import api from '@/db/apiClient';

export function respondToInviteThunk(
  invite: Invitation,
  accept: boolean,
  switchOrganisation: (orgId: string) => void,
) {
  return async (dispatch: AppDispatch) => {
    const { success, message } = await api.asEducator.respondToInvite(
      invite.token,
      accept,
    );

    if (!success) {
      throw new Error(message);
    }

    if (accept) {
      const claims = await refreshUserClaims(
        (claims) =>
          !!claims &&
          Array.isArray(claims.organisationIds) &&
          claims.organisationIds.includes(invite.organisationId),
      );
      if (claims) {
        dispatch(setClaims(claims));
        switchOrganisation(invite.organisationId);
      } else {
        window.location.reload();
      }
    }
  };
}
